<template>
  <div class="divPrePublish">
    <div
      class="divPublishDate"
      :style="{ color: color, background: bgColor }"
      v-if="publishFlag === 'publish'"
    >
      {{ msg }}
    </div>
    <div class="divRestOfDay" v-if="publishFlag === 'rest'">
      距离项目发布剩余
      <div>{{ restOfDay }}</div>
      天
    </div>
  </div>
</template>

<script>
let moment = require("moment");
moment.locale("zh-cn");
export default {
  data() {
    return {
      publishDate: "",
      restOfDay: "",
      publishFlag: "none",
    };
  },
  props: {
    data: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#478aef",
    },
    bgColor: {
      type: String,
      default: "#e1eeff",
    },
    links: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    data(newValue) {
      this.publishDate = moment(newValue).format("YYYY.MM.DD");
      let num = moment(newValue).diff(moment(), "days");
      if (num > 0) {
        this.publishFlag = "rest";
        if (num < 10) {
          num = "0" + num;
        }
      } else {
        this.publishFlag = "publish";
      }
      this.restOfDay = num;
    },
  },
  computed: {
    msg() {
      let msgInfo = `项目发布时间: ${this.publishDate} `;
      this.links.forEach((item) => {
        if (!item.url) {
          msgInfo = "项目升级中...";
          return;
        }
      });
      return msgInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.divPrePublish {
  margin-top: 25px;
  .divPublishDate {
    width: 202px;
    height: 30px;
    border-radius: 15px;
    background-color: #e1eeff;
    line-height: 30px;
    text-align: center;
  }
  .divRestOfDay {
    font-size: 16px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #ffffff;
    line-height: 21px;
    letter-spacing: 5px;
    div {
      display: inline-block;
      background: #424242;
      border: 2px solid #252525;
      border-radius: 4px;
      font-size: 24px;
      font-family: UniDreamLED;
      text-align: center;
      color: #3bf35f;
      line-height: 28px;
      vertical-align: middle;
      text-align: center;
      margin-left: -6px;
      padding-left: 4px;
    }
  }
}
</style>
